import React from "react";
import RadioBlocks from "src/components/Input/RadioBlocks/RadioBlocks";
import SimpleRadioButtons from "src/components/Input/SimpleRadioButtons/SimpleRadioButtons";
import { Wall } from "src/types/configuration";
// @ts-ignore
import cloneDeep from "lodash/cloneDeep";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import RadioBlocksExtended from "../RadioBlocksExtended/RadioBlocksExtended";
import { getDisabledDoors } from "src/helpers/wallValidation";

export const doors = [
  {
    id: 100,
    name: "Geen deur",
    imageUrl: `${process.env.PUBLIC_URL}/images/empty.svg`,
    color: "",
    value: "empty",
    price: 0,
    description: "",
  },
  {
    id: 1,
    name: "Douglas enkele deur dicht 78 x 195 cm",
    imageUrl: `${process.env.PUBLIC_URL}/images/door1.png`,
    color: "",
    value: "dichte_73cm",
    price: 0,
    description: "",
  },
  // {
  //   id: 2,
  //   name: "Dichte deur 100cm",
  //   imageUrl: `${process.env.PUBLIC_URL}/images/door1.png`,
  //   color: "",
  //   value: "dichte_100cm",
  //   price: 0,
  //   description: "",
  // },
  {
    id: 3,
    name: "Douglas enkele deur met raam 84 x 195 cm",
    imageUrl: `${process.env.PUBLIC_URL}/images/door3.png`,
    color: "",
    value: "stapeldorpeldeur",
    price: 0,
    description: "",
  },
  {
    id: 4,
    name: "Douglas dubbele deur dicht 186 x 195 cm",
    imageUrl: `${process.env.PUBLIC_URL}/images/door4.png`,
    color: "",
    value: "dubbele_dichte",
    price: 0,
    description: "",
  },
  {
    id: 5,
    name: "Douglas dubbele stapeldorpel deur met raam 186 x 195cm",
    imageUrl: `${process.env.PUBLIC_URL}/images/door5.png`,
    color: "",
    value: "dubble_stapeldorpeldeur",
    price: 0,
    description: "",
  },
];

const sides = [
  { label: "links-draaiend", value: "right" },
  { label: "rechts-draaiend", value: "left" },
];

interface DoorSelectProps {
  id: string;
  wall?: Wall;
  value: string;
  subValue: string;
  onChange: (value: string) => void;
  onSubChange: (value: string) => void;
}

const DoorSelect: React.FC<DoorSelectProps> = ({
  id,
  wall,
  value,
  subValue,
  onChange,
  onSubChange,
}) => {
  const { state, configurator } = useConfiguration();
  const configWall = wall
    ? configurator.findWallByPosition(wall?.position)
    : null;

  // Get disabled doors using the helper function
  const availableDoors = doors.map((d) => d.value);
  const disableValues =
    wall && configWall
      ? getDisabledDoors(wall, configurator, state.roofType, availableDoors)
      : [];

  const doorsWithComponent = doors.map((door, index) => {
    if (door.value === "empty") return door;

    return {
      ...door,
      // component: (
      //   <SimpleRadioButtons
      //     name={`door-${door.id}-${id}-${wall?.id}-${wall?.storage}`}
      //     value={subValue}
      //     values={sides}
      //     onChange={onSubChange}
      //   />
      // ),
    };
  });
  return (
    <>
      <RadioBlocksExtended
        blocks={doorsWithComponent}
        value={value}
        onChange={onChange}
        className={"door-radio-blocks"}
        disableValues={disableValues}
        stopPropagation={true}
      />
    </>
  );
};

export default DoorSelect;
